import { render, staticRenderFns } from "./districtList.vue?vue&type=template&id=7d85e7fb&scoped=true&"
import script from "./districtList.vue?vue&type=script&lang=js&"
export * from "./districtList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85e7fb",
  null
  
)

export default component.exports